import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 2,
	kind: "quiz",
	label: "Pregunta 3 (plantilla)",
	nextRoute: ROUTES.SCENARIO2_FIN,
});
